import React from "react";

import { Theme, useTheme } from "@mui/material/styles";

import {
  logDebug,
  mergeProperties,
  packableDeepClone,
} from "packable-components";
import {
  OrderItemAction,
  OrderUserCancelActionsProps,
  ShippingStatus,
} from "./Order.types";
import { Button, Grid, TextField } from "@mui/material";

const useStyles = (theme: Theme) => ({
  OrderActionContainer: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignContent: "center",
    alignItems: "center",
  },
  OrderUserCancelActionButtonUnselected: {
    muiColor: "secondary",
    muiVariant: "outlined",
    width: "240px", 
  },
  OrderUserCancelActionButtonSelected: {
    muiColor: "secondary",
    muiVariant: "contained",
    width: "240px", 
  },
  OrderActionSingleItemRowContainer: {
    padding: 1, 
    width: "512px",
    display: "flex",
    flexWrap: "wrap",
    flexDirection: "row",
    justifyContent: "flex-start",
  },
  OrderActionRightAlignedRowContainer: {
    width: "512px",
    display: "flex",
    flexWrap: "wrap",
    flexDirection: "row",
    justifyContent: "flex-end",
  },
  OrderUserCancelActionButtonContainer: {
    pb: 1,
  },
  OrderActionContentFullWidthTextFieldContainer: {
    width: "100%",
  },
  OrderActionContentFullWidthTextField: {
    width: "100%",
  },
});

export const OrderUserCancelAction: React.FC<OrderUserCancelActionsProps> = (
  props
): React.JSX.Element => {
  const { originalStatus, itemLabel, orderItemAction, onOrderItemActionUpdate, disabled = false, styles } =
    props;

  logDebug("OrderUserCancelAction PROPS");
  logDebug(props);

  const theme = useTheme();

  const defaultStyles = useStyles(theme);
  const effectiveStyles =
    styles === undefined
      ? defaultStyles
      : mergeProperties(defaultStyles, styles);

  logDebug("OrderUserCancelAction effectiveStyles");
  logDebug(effectiveStyles);

  const handleNoteValueChange = (event: any) => {
    let newOrderItemAction = packableDeepClone(orderItemAction);
    newOrderItemAction.note = event.target.value;
    onOrderItemActionUpdate(newOrderItemAction);
  };

  const handleCancelClick = (event: React.MouseEvent<HTMLElement>) => {
    let newOrderItemAction: OrderItemAction = packableDeepClone(orderItemAction);
    if (newOrderItemAction.shippingStatus === ShippingStatus.CANCEL_REQUESTED) {
      newOrderItemAction.shippingStatus = originalStatus;
    } else {
      newOrderItemAction.shippingStatus = ShippingStatus.CANCEL_REQUESTED;
    }
    onOrderItemActionUpdate(newOrderItemAction);
  };

  return (
    <>
      <Grid 
        className="OrderActionContainer"
        sx={effectiveStyles.OrderActionContainer}
    >
        <Grid
          className="OrderActionSingleItemRowContainer"
          sx={effectiveStyles.OrderActionSingleItemRowContainer}
        >
          <Grid
            className="OrderUserCancelActionButtonContainer"
            sx={effectiveStyles.OrderUserCancelActionButtonContainer}
          >
            <Button
              className={
                orderItemAction.shippingStatus ===
                ShippingStatus.CANCEL_REQUESTED
                  ? "OrderUserCancelActionButtonSelected"
                  : "OrderUserCancelActionButtonUnselected"
              }
              sx={
                orderItemAction.shippingStatus ===
                ShippingStatus.CANCEL_REQUESTED
                  ? effectiveStyles.OrderUserCancelActionButtonSelected
                  : effectiveStyles.OrderUserCancelActionButtonUnselected
              }
              disabled={disabled}
              onClick={handleCancelClick}
              variant={
                orderItemAction.shippingStatus ===
                ShippingStatus.CANCEL_REQUESTED
                  ? effectiveStyles.OrderUserCancelActionButtonSelected
                      .muiVariant
                  : effectiveStyles.OrderUserCancelActionButtonUnselected
                      .muiVariant
              }
              color={
                orderItemAction.shippingStatus ===
                ShippingStatus.CANCEL_REQUESTED
                  ? effectiveStyles.OrderUserCancelActionButtonSelected.muiColor
                  : effectiveStyles.OrderUserCancelActionButtonUnselected
                      .muiColor
              }
            >
              {orderItemAction.shippingStatus ===
              ShippingStatus.CANCEL_REQUESTED
                ? `Undo Cancel Storage ${itemLabel}`
                : `Cancel Storage ${itemLabel}`}
            </Button>
          </Grid>
        </Grid>
        {orderItemAction.shippingStatus ===
          ShippingStatus.CANCEL_REQUESTED && (
          <Grid
            className="OrderActionSingleItemRowContainer"
            sx={effectiveStyles.OrderActionSingleItemRowContainer}
          >
            <Grid
              className="OrderActionContentFullWidthTextFieldContainer"
              sx={effectiveStyles.OrderActionContentFullWidthTextFieldContainer}
            >
              <TextField
                className="OrderActionContentFullWidthTextField"
                sx={effectiveStyles.OrderActionContentFullWidthTextField}
                id="note"
                label="Note"
                value={orderItemAction.note || ""}
                onChange={handleNoteValueChange}
              />
            </Grid>
          </Grid>
        )}
      </Grid>
    </>
  );
};

export default OrderUserCancelAction;
